import { create } from 'zustand';
import type { Pattern } from '../types/patterns';
interface IDatasetStore {
  paths: any[];
  setPaths: (paths: any[]) => void;
  sankey: any[];
  setSankey: (sankey: any[]) => void;
  patterns: Pattern[];
  setPatterns: (patterns: Pattern[]) => void;
  flows: any[];
  setFlows: (flows: IDatasetStore['flows']) => void;
  patternSankey: any[];
  setPatternSankey: (patternSankey: any[]) => void;
}

export const useDatasetStore = create<IDatasetStore>((set) => ({
  paths: [],
  setPaths: (paths: any[]) => set({ paths }),
  sankey: [],
  setSankey: (sankey: any[]) => set({ sankey }),
  patternSankey: [],
  setPatternSankey: (patternSankey: any[]) => set({ patternSankey }),
  patterns: [],
  setPatterns: (patterns: Pattern[]) => set({ patterns }),
  flows: [],
  setFlows: (flows: IDatasetStore['flows']) => set({ flows }),
}));
